import { Alert, DialogContent, Divider } from "@mui/material";
import { Loading } from "@ssf/components";
import { MembershipType } from "@ssf/memdb-api";
import { useQuery } from "@tanstack/react-query";
import type { ReactNode } from "react";
import type { UseQueryClub } from "../lib/api.js";
import { documentsInQuery } from "../lib/signApi.js";
import {
  type CheckValuesWithFile,
  Document,
  PreviewFile,
  SignatureList,
} from "./index.js";

export type DocumentDialogContentProps = (
  | { type?: undefined; data?: undefined }
  | { type: "checkValue"; data: CheckValuesWithFile }
  | { type: "registration"; data: UseQueryClub["registrations"][0] }
) & { children?: ReactNode };

export const DocumentDialogContent = ({
  children,
  ...props
}: DocumentDialogContentProps) => {
  if (props.data?.documentid) {
    const approved =
      props.type === "checkValue"
        ? props.data.approved
        : props.data.membershiptype < MembershipType.NoneOfficialMember;
    return (
      <DocumentContent documentId={props.data.documentid} approved={approved}>
        {children}
      </DocumentContent>
    );
  }
  if (props.type === "checkValue" && props.data.fileUrl) {
    return <PreviewFile file={props.data.fileUrl} />;
  }
  return null;
};

const DocumentContent = ({
  documentId,
  approved,
  children,
}: {
  documentId: string;
  approved?: boolean;
  children?: ReactNode;
}) => {
  const { data: document, isLoading } = useQuery({
    ...documentsInQuery(documentId),
    select: (documents) => documents?.[0],
  });

  if (isLoading) {
    return <Loading />;
  }

  if (!document) {
    return <Alert severity="error">Dokumentet kunde inte laddas</Alert>;
  }

  return (
    <>
      <DialogContent>
        <Document document={document} />
      </DialogContent>
      {children}
      <Divider />
      <SignatureList document={document} approved={approved} />
    </>
  );
};
